import React from 'react';

interface DefaultDepartmentIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const DefaultDepartmentIcon: React.FC<DefaultDepartmentIconProps> = ({
  color = '#2372b9',
  height = 14,
  width = 14,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 100 100"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
  >
    {/* Circle background */}
    <circle
      cx="50"
      cy="50"
      r="45"
      fill="none"
      stroke={color}
      strokeWidth="6"
    />
    {/* Letter D in the center */}
    <text
      x="50"
      y="50"
      textAnchor="middle"
      dominantBaseline="central"
      fill={color}
      fontSize="50"
      fontWeight="bold"
      fontFamily="Arial, sans-serif"
    >
      D
    </text>
  </svg>
);

export default DefaultDepartmentIcon;
